import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import Sparkline from '../../../components/Sparklines';

export const module1Keys = (t) => [
    {
        key: 'clicksL',
        label: t('search.search_appearance.module1.clicks'),
        icon: 'pagev-view',
    },
    {
        key: 'impressionsL',
        label: t('search.search_appearance.module1.impressions'),
        icon: 'pagev-view',
    },
    {
        key: 'ctrL',
        label: t('search.search_appearance.module1.avgCTR'),
        yAxisID: 'y1',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'search',
    },
    {
        key: 'positionL',
        label: t('search.search_appearance.module1.position'),
        icon: 'pagev-view',
        yAxisID: 'y2',
    },
];

export const tableColumns = (t) => [
    {
        label: t('search.search_appearance.module2.searchAppearance'),
        key: 'searchappearance',
        data: 'searchappearance',
        Component: Cell,
    },
    {
        label: t('search.search_appearance.module2.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        label: t('search.search_appearance.module2.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        label: t('search.search_appearance.module2.trend'),
        key: 'sparkline',
        data: 'sparkline',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return '-';

            return (
                <Sparkline
                    labels={item.dateL.map((x) => x.value)}
                    dataL={item.clicksL}
                    keyName={t('search.search_appearance.module2.clicks')}
                />
            );
        },
    },
    {
        label: t('search.search_appearance.module2.position'),
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        label: t('search.search_appearance.module2.avgCTR'),
        key: 'avgCTR',
        data: 'avgCTR',
        Component: Cell,
        renderCell: ({ item }) => numeral(item.clicks / item.impressions).format('0.00%'),
    },
];

export function getPercentForChart(allData, oneData) {
    const sumAllData = allData.reduce((acc, curr) => acc + curr, 0);
    const percent = (100 * oneData) / sumAllData;
    return percent;
}
